/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { RegexCompat } from '../../compat/RegexCompat';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class ModelUtils {
    /**
     * Returns true if the given object is null or undefined.  Obviously Java does not have the concept
     * of "undefined" but this must also support the case where this code is running in Javascript.
     * @param {*} object
     * @return {boolean}
     */
    public static isNullOrUndefined(object : any) : boolean {
        return NodeCompat.isNullOrUndefined(object);
    }

    /**
     * The opposite of isNullOrUndefined.
     * @param {*} object
     * @return {boolean}
     */
    public static isDefined(object : any) : boolean {
        return !ModelUtils.isNullOrUndefined(object);
    }

    /**
     * Detects the appropriate path parameter names from a path.  For example, if the
     * string "/resources/{fooId}/subresources/{barId}" is passed in, the following
     * string array will be returned:  [ "fooId", "barId" ]
     * @param {string} path
     * @return {string[]}
     */
    public static detectPathParamNames(path : string) : Array<string> {
        let paramNames : Array<string> = <any>([]);
        let matches : Array<string[]> = RegexCompat.findMatches(path, "\\{([^\\}]+)\\}");
        for(let index217=0; index217 < matches.length; index217++) {
            let match = matches[index217];
            {
                let name : string = match[1];
                /* add */(paramNames.push(name.trim())>0);
            }
        }
        return paramNames;
    }
}
ModelUtils["__class"] = "io.apicurio.datamodels.cmd.util.ModelUtils";



